export default class Header {
    constructor(query = '.site-header', offset = 10) {
        const el = document.querySelector(query);
        if (!el) return;

        this.header = el;
        this.offset = offset;

        this.init();
    }

    init() {
        this.onScroll();
        window.addEventListener('scroll', () => this.onScroll());
    }

    onScroll() {
        const scroll = window.scrollY || window.pageYOffset;

        if (scroll > this.offset) {
            this.header.classList.add('scrolled');
        } else {
            this.header.classList.remove('scrolled');
        }
    }
}